import { WeddingWebsiteQuery, Maybe } from '../generated/graphql';

const removeGuestWeddingTypename = (guestWedding?: Maybe<WeddingWebsiteQuery['guestWedding']>) => {
  if (!guestWedding) return null;

  const { __typename, ...gw } = guestWedding;
  const { questions } = gw;
  const cleanQuestions = questions?.map(question => {
    const { __typename, options, ...q } = question;
    const cleanOptions = options?.map(({ __typename, ...rest }) => ({ ...rest }));

    return { ...q, options: cleanOptions };
  });

  return { ...gw, questions: cleanQuestions };
};

export default removeGuestWeddingTypename;
